export default __webpack_public_path__ + "static/media/choose_2.baffbbe2.png";